import { getDefects, getDefectsCodes } from "../../services/defectService";
import { setData, setDefectCodes, setError, setFilteredDefects, setLoading } from "../slices/defectSlice";
import { AppThunk } from "../store";

export const fetchDefects = (inspectionId: string): AppThunk => async (dispatch, getState) => {
    dispatch(setLoading(true));
    dispatch(setError(false));

    try {
        const response = await getDefects(inspectionId);

        if (response) {
            dispatch(setData(response))
            dispatch(setFilteredDefects(response))
        } else {
            throw Error('no data');
        }
    } catch (e) {
        console.error(e);
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
}

export const fetchDefectCodes = (): AppThunk => async (dispatch, getState) => {
    dispatch(setLoading(true));
    dispatch(setError(false));

    try {
        const response = await getDefectsCodes();

        if (response) {
            dispatch(setDefectCodes(response))
        } else {
            throw Error('no data');
        }
    } catch (e) {
        console.error(e);
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
}